// extracted by mini-css-extract-plugin
module.exports = {"search__wrapper":"style_search__wrapper__2CyeJ"};